import { useOutletContext } from 'react-router-dom'

import type { SoftwareManagementApplicationDetailsPageQueryQuery } from 'generated/resources/graphql'
import {
  SoftwareManagementCardFragment,
  SoftwareManagementExchangeCurrencyFragment,
  SoftwareManagementSoftwareSetupItemFragment,
} from 'generated/resources/graphql'

type SoftwareManagementMonthlySoftwareCost = NonNullable<
  SoftwareManagementApplicationDetailsPageQueryQuery['softwareManagement']['softwareSetup']
>['monthlySoftwareCosts'][number]

export interface ApplicationDetailsRouterOutletContextParams {
  softwareSetup: SoftwareManagementSoftwareSetupItemFragment
  card: SoftwareManagementCardFragment | null | undefined
  canManagePurchaseFinancialDocuments: boolean
  currency: string
  softwareCosts: SoftwareManagementMonthlySoftwareCost[]
  currencies: SoftwareManagementExchangeCurrencyFragment[]
}

export const useApplicationDetailsRouterParams = () =>
  useOutletContext<ApplicationDetailsRouterOutletContextParams>()
